import React from 'react';
import {FadeIn} from '../ui/FadeIn';

const CTASection=()=> {
return (
    <section className="py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-neon/20 via-brand-electric/10 to-transparent"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-50"></div>

      <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
        <FadeIn>
          <h2 className="text-4xl md:text-6xl font-black text-white mb-6 drop-shadow-[0_2px_20px_rgba(0,229,255,0.3)]">
            Ready to transform your first video?
          </h2>
          <p className="text-xl text-white/80 mb-10 drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]">
            It takes 2 minutes to get your first slide deck.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <button className="btn-cta py-4 px-12 text-lg w-full sm:w-auto text-brand-neon">
              Start Free
            </button>
            <button className="btn-secondary py-4 px-10 text-lg w-full sm:w-auto text-brand-electric">
              Book a Demo →
            </button>
          </div>

          <p className="text-sm text-white/60 mb-10">No credit card required</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/70">
            <div className="flex items-center gap-2"><span>🔒</span> SOC 2 Type II</div>
            <div className="hidden sm:block text-brand-electric/30">|</div>
            <div className="flex items-center gap-2"><span>⚡</span> Results in minutes</div>
            <div className="hidden sm:block text-brand-electric/30">|</div>
            <div className="flex items-center gap-2"><span>🎯</span> No credit card required</div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default CTASection;